/**
 * @file コンポーネント：テキストエリア DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル読み込み
import { StyledTextarea } from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ReactDOM
    return (
        <StyledTextarea
            {...props}
            className={props.isWide === true && "is-wide"}
            cols={props.cols}
            id={props.id}
            maxlength={props.maxlength}
            name={props.name}
            placeholder={props.placeholder}
            ref={props.refTextarea}
            rows={props.rows ? props.rows : 5}
        >
            {props.text}
        </StyledTextarea>
    );
};
